<template>
  <div class="main">
    <div class="container">
      <!-- crumb -->
      <ftft-crumb :lv1="crumbLv1" :lv1RouteName="crumbLv1RouteName"
                  :now="pageName" />
      <!-- tab-title -->
      <h1 class="tit-type1" :title="crumbLv1">{{ crumbLv1 }}</h1>
      <!-- tab -->
      <ftft-tab-menu :items="items" :tabMenuActiveItem="pageName" />
      <!-- title -->
      <h1 class="tit-type2" :title="pageName">{{ pageName }}</h1>
      <!-- content -->
      <router-view :key="$route.fullPath"/>
    </div>
  </div>
</template>

<script>
import FtftCrumb from '@/components/BreadCrumb.vue'
import FtftTabMenu from '@/components/TabMenu.vue'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('Transaction')

export default {
  components: { FtftCrumb, FtftTabMenu },
  data () {
    return {
      items: [
        {
          route: {
            name: 'Estimate'
          },
          name: '即時預估淨值'
        },
        {
          route: {
            name: 'ComparisonChart'
          },
          name: '淨值走勢'
        },
        {
          route: {
            name: 'PCF'
          },
          name: '申購買回清單'
        },
        {
          route: {
            name: 'IndexTrack'
          },
          name: '追蹤差距'
        },
        {
          route: {
            name: 'RedemptionInfo'
          },
          name: '申贖費用資訊'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'crumbLv1', 'crumbLv1RouteName',
      'pageName'
    ])
  }
}
</script>
